import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { ToolName } from '../../../../cross-team-shared/tools-names';
import { ToolConfig } from '../../../../cross-team-shared/tools.config';
import { makeTooltipProvider } from '../../../../cross-team-shared/tooltips/tooltip-utils';
import { MainVideoToolbarComponent } from './main-video-toolbar.component';

@Component({
  selector: 'h3-split-view-main-video-toolbar',
  templateUrl:
    '../../../shared/toolbars/abstract-main-toolbar/abstract-main-toolbar-2d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [makeTooltipProvider({ position: 'right' })],
  standalone: false,
})
export class SplitViewMainVideoToolbarComponent extends MainVideoToolbarComponent {
  protected override buildButtonFromTool(toolConfig: ToolConfig<ToolName>) {
    return {
      ...super.buildButtonFromTool(toolConfig),
      visible$: this.selectedToolStore.$.pipe(
        map((selectedTool) => selectedTool === toolConfig.name),
      ),
    };
  }
}
